import "./environmentalDetails.css";
import Header from "./subComponents/header";
import Footer from "./subComponents/footer";
import Patterns from "./subComponents/patterns";
import { useSelector } from "react-redux";

const EnvironmentalDetails = (props) => {
  const { tableContent } = props;
  const pageDetail = tableContent.find(
    (item) => item.title === "Environmental Details"
  );
  const quantityInfo = useSelector((state) => state.quantity);
  const roofData = quantityInfo?.roofData || [];
  const roofIndex = quantityInfo.roofNo;
  const check = quantityInfo.allRoof;
  const roofDetail = roofData[roofIndex];

  let totalCapacity = 0;

  if (check) {
    for (let i = 0; i < roofData.length; i++) {
      const element = roofData[i];
      if (element.structureType === "Single") {
        totalCapacity += Number(element.totalKilowatt);
      } else {
        const totalKilowatt = Number(
          element.multipleStructure
            .reduce((total, data) => total + data.totalKilowatt, 0)
            .toFixed(1)
        );
        totalCapacity += Number(totalKilowatt);
      }
    }
  } else {
    if (roofDetail.structureType === "Single") {
      totalCapacity += Number(roofDetail.totalKilowatt);
    } else {
      const totalKilowatt = Number(
        roofDetail.multipleStructure
          .reduce((total, data) => total + data.totalKilowatt, 0)
          .toFixed(1)
      );
      totalCapacity += Number(totalKilowatt);
    }
  }

  let energy = 1500 * totalCapacity;

  let coalSaved = ((energy * 0.4) / 1000).toFixed(2);
  let co2Avoided = ((energy * 0.475) / 1000).toFixed(2);
  let treesPlanted = (co2Avoided / 40).toFixed(2);

  let environmentalDet = [
    {
      title: "Value source",
      value: "METEOSAT",
    },
    {
      title: "Irradiance on tilted surface",
      value: "SOLIS reduced irradiance",
    },
    {
      title: "Diffuse irradiation",
      value: "SOLIS clear-sky module",
    },
    {
      title: "CO2 avoided",
      value: `${co2Avoided} tons/year`,
    },
    {
      title: "Tree planted",
      value: `${treesPlanted} k/year`,
    },
    {
      title: "Coal avoided",
      value: `${coalSaved} tons/year`,
    },
  ];

  function tableRender(tableData) {
    return (
      <div className="render-function">
        <table className="render-table">
          <thead>
            <tr>
              <td>Property</td>
              <td>Value</td>
            </tr>
          </thead>
          <tbody>
            {tableData.map((item, index) => {
              return (
                <tr key={index} className={index % 2 === 0 ? "one" : "two"}>
                  <td className="left">{item.title}</td>
                  <td className="right">{item.value}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div id="inverter-config" className="inverter-config">
      {/* Patterns */}
      <Patterns />
      {/* Header */}
      <Header />
      {/* Main Body */}
      <main className="ic-body">
        <p>Environmental Details</p>
        <div className="data-tables">
          {/* PV Panel */}
          {tableRender(environmentalDet)}
        </div>
        <div className="stats-container">
          {/* First */}
          <div className="stat color-1">
            <span className="number">{coalSaved}</span>
            <span className="small">&nbsp;(tons/year)</span>
            <br />
            <span className="normal">Standard coal saved</span>
            <img src="./images/report/first.svg" alt="first" />
          </div>
          <div className="stat color-2">
            <span className="number"> {co2Avoided} </span>
            <span className="small">&nbsp;(tons/year)</span>
            <br />
            <span className="normal">CO2 avoided</span>
            <img src="./images/report/second.svg" alt="second" />
          </div>
          <div className="stat color-3">
            <span className="number">{treesPlanted}</span>
            <span className="small">&nbsp;(k/year)</span>
            <br />
            <span className="normal">Equivalent trees planted</span>
            <div style={{ height: "1px" }} />
            <img
              className="third-image"
              src="./images/report/third.svg"
              alt="third"
            />
          </div>
        </div>
      </main>

      {/* Footer */}
      <Footer
        pageNo={`${pageDetail ? pageDetail.pageNo : 12}/${
          tableContent[tableContent.length - 1].pageNo
        }`}
      />
    </div>
  );
};

export default EnvironmentalDetails;
